/* eslint-disable */
import { Component } from "react";
import { Dropdown } from "../../reuseable";

export default class DropdownOrData extends Component {
  render() {
    const {
      mode,
      fields,
      id,
      className,
      type = "text",
      placeholder = "Pilih",
      body,
      if_string_is_empty = "",
    } = this.props;

    if (mode === "setup") {
      return (
        <Dropdown
          className="w_100 inline"
          placeholder={placeholder}
          filter_on
          is_enable_empty
          value={body?.[id] || ""}
          onChange={(value) => {
            if (this.props.onChange) {
              this.props.onChange(id, value);
            }
          }}
        >
          {fields &&
            fields?.map((field) => (
              <option key={field.key} value={field.key}>
                {field.name}
              </option>
            ))}
        </Dropdown>
      );
    } else {
      if (type === "email") {
        return <a id={id}>{"-"}</a>;
      } else {
        return (
          <p id={id} className={className}>
            {if_string_is_empty}
          </p>
        );
      }
    }
  }
}
